import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "form-container" }

import { ref, computed, ComputedRef } from 'vue';
import MultipleDeviceTypeAutoComplete from '@/components/AutoCompletes/MultipleDeviceTypeAutoComplete.vue';
import { isDeviceTypesValide, isMemoValide } from '@/services/validators';
import deviceType from '@/types/DeviceType';
import i18n from '@/lang/i18n';
import { firstFile } from '@/services/functions';


export default /*@__PURE__*/_defineComponent({
  __name: 'FirmwareCreateForm',
  props: {
    creating: { type: Boolean }
  },
  emits: ['close-modal', 'send-form'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const firmwareFile = ref<File | File[] | null | undefined>(undefined);
const memo = ref<string>('');
const version = ref<string>('');
const selectedDeviceTypes = ref<deviceType[]>([]);
const errors = ref<{
  device_type: Array<string>;
  version: Array<string>;
  firmware_file: Array<string>;
  memo: Array<string>;
}>({
  device_type: [],
  version: [],
  firmware_file: [],
  memo: [],
});

const isValide: ComputedRef<boolean> = computed(() => {
  return Object.values(errors.value).every((errors) => errors.length === 0);
});

const createBtnText: ComputedRef<string> = computed(() => {
  return props.creating ?
    i18n.global.t('pages.firmwareList.form.button.saving') :
    i18n.global.t('common.saveBtn');
});

const validateAndSendForm = (): void => {
  if (props.creating) {
    return;
  }
  validateForm();
  if (isValide.value) {
    sendForm();
  }
};

const validateForm = (): void => {
  validateDeviceTypes();
  validateVersion();
  validateFirmwareFile();
  validateMemo();
};

const validateDeviceTypes = (): void => {
  const errorMessage = isDeviceTypesValide(selectedDeviceTypes.value);
  if (errorMessage === null) {
    errors.value.device_type = [];
    return;
  }
  errors.value.device_type = [errorMessage];
};

const validateVersion = (): void => {
  const errorMessage = getVersionValidErrorMessage();
  if (errorMessage === null) {
    errors.value.version = [];
    return;
  }
  errors.value.version = [errorMessage];
};

const validateFirmwareFile = (): void => {
  const errorMessage = getFirmwareFileValidErrorMessage();
  if (errorMessage === null) {
    errors.value.firmware_file = [];
    return;
  }
  errors.value.firmware_file = [errorMessage];
};

const validateMemo = (): void => {
  let errorMessage = isMemoValide(memo.value);
  if (errorMessage === null) {
    errors.value.memo = [];
    return;
  }
  errors.value.memo = [errorMessage];
};

const sendForm = (): void => {
  const file = firstFile(firmwareFile.value);
  if (!file) {
    return;
  }

  emit('send-form', {
    payload: {
      memo: memo.value,
      ar_device_type_ids: selectedDeviceTypes.value.map(
        (deviceType) => deviceType.id
      ),
      version: version.value,
    },
    firmwareFile: file,
  });
};

const getVersionValidErrorMessage = (): string | null => {
  if (version.value.length < 1) {
    return i18n.global.t('pages.firmwareList.form.validate.versionEmpty');
  } else {
    const matches = new RegExp(/^[\w\d.\-_]+$/).exec(version.value);
    if (!matches || matches.length < 1) {
      return i18n.global.t('pages.firmwareList.form.validate.format');
    }
    if (version.value.length > 128) {
      return i18n.global.t('pages.firmwareList.form.validate.versionOverLenght');
    }
  }
  return null;
};

const getFirmwareFileValidErrorMessage = (): string | null => {
  if (!firstFile(firmwareFile.value)) {
    return i18n.global.t('pages.firmwareList.form.validate.noAttached');
  }
  return null;
};

return (_ctx: any,_cache: any) => {
  const _component_v_file_input = _resolveComponent("v-file-input")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_card, {
      class: "mx-auto",
      title: _unref(i18n).global.t('pages.firmwareList.form.title.create')
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_container, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_file_input, {
              modelValue: firmwareFile.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((firmwareFile).value = $event)),
              accept: ".tar",
              label: _unref(i18n).global.t('pages.firmwareList.form.label.firmware'),
              ref: "firmware-file",
              onChange: validateFirmwareFile,
              "error-messages": errors.value.firmware_file
            }, null, 8, ["modelValue", "label", "error-messages"]),
            _cache[5] || (_cache[5] = _createElementVNode("div", { class: "placement-adjustment" }, null, -1)),
            _createVNode(MultipleDeviceTypeAutoComplete, {
              modelValue: selectedDeviceTypes.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedDeviceTypes).value = $event)),
              onBlur: validateDeviceTypes,
              "error-messages": errors.value.device_type
            }, null, 8, ["modelValue", "error-messages"]),
            _cache[6] || (_cache[6] = _createElementVNode("div", { class: "placement-adjustment" }, null, -1)),
            _createVNode(_component_v_text_field, {
              modelValue: version.value,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((version).value = $event)),
              color: "primary",
              label: _unref(i18n).global.t('pages.firmwareList.version'),
              onBlur: validateVersion,
              "error-messages": errors.value.version
            }, null, 8, ["modelValue", "label", "error-messages"]),
            _cache[7] || (_cache[7] = _createElementVNode("div", { class: "placement-adjustment" }, null, -1)),
            _createVNode(_component_v_textarea, {
              label: _unref(i18n).global.t('pages.firmwareList.form.label.memo'),
              modelValue: memo.value,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((memo).value = $event)),
              onBlur: validateMemo,
              "error-messages": errors.value.memo
            }, null, 8, ["label", "modelValue", "error-messages"]),
            _cache[8] || (_cache[8] = _createElementVNode("div", { class: "placement-adjustment" }, null, -1))
          ]),
          _: 1
        }),
        _createVNode(_component_v_divider, { class: "my-4" }),
        _createVNode(_component_v_card_actions, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_spacer),
            _createVNode(_component_v_btn, {
              class: "ma-2 reset-btn",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('close-modal')))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(i18n).global.t('pages.common.button.close')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_v_btn, {
              class: "ma-2 exec-btn",
              onClick: validateAndSendForm,
              style: _normalizeStyle({
            backgroundColor: __props.creating ? '#B3B8BB' : '',
          })
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(createBtnText.value), 1)
              ]),
              _: 1
            }, 8, ["style"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["title"])
  ]))
}
}

})